import { datadogLogs } from '@datadog/browser-logs';
import { API_ENV, DATADOG_SITE } from '../constants';

const CLIENT_TOKEN = 'pubc889ffff426ed9c686812fa21927998d';

interface LoggerInitOptions {
  merchantId: string;
  employeeId: string;
}

const Logger = {
  init({ merchantId, employeeId }: LoggerInitOptions): void {
    const env = API_ENV === 'staging' ? 'staging' : 'prod';

    datadogLogs.init({
      env,
      clientToken: CLIENT_TOKEN,
      service: 'web-calendar-app',
      site: DATADOG_SITE,
      forwardErrorsToLogs: false,
      forwardConsoleLogs: [],
      sessionSampleRate: 100,
      beforeSend: (log) => {
        (log as Record<string, unknown>).user = { id: employeeId, merchantId };
        return true;
      },
    });

    datadogLogs.createLogger('default', {
      level: 'error',
      handler: ['console', 'http'],
    });
  },

  error(message: string, payload: Record<string, unknown> = {}): void {
    const logger = datadogLogs.getLogger('default');
    logger?.error(message, payload);
  },
};

export default Logger;
